import { render, staticRenderFns } from "./GStarInspector.vue?vue&type=template&id=763ca5bc&"
import script from "./GStarInspector.vue?vue&type=script&lang=js&"
export * from "./GStarInspector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports